<template>
  <b-nav-item-dropdown
    v-if="devices.length > 0"
    class="dropdown-notification mr-75"
    menu-class="dropdown-menu-media dropdown-menu-right"
    left
  >
    <template #button-content>
      <div :class="['d-flex justify-content-center', { 'mt-1': isOnCall }]">
        <div class="d-flex align-items-center justify-content-center">
          <feather-icon
            :badge="calls.length + pbx_calls.length"
            badge-classes="bg-danger"
            :stroke="iconColor"
            icon="PhoneCallIcon"
            size="21"
            :class="[
              'text-body btn-toggle-config-mode',
              { 'on-call': isOnCall },
              { ringing: isRinging },
              { ringing: isCalling },
            ]"
          />
        </div>

        <b-badge pill variant="warning" v-if="isOnCall" class="ml-1 p-1">
          {{ $t("sip.dropdown.on_call_with") + " " + unit_user_caller }}
        </b-badge>
        <b-badge pill variant="warning" v-if="isOnCall" class="ml-1 p-1">
          {{ formatTime(timeCall) }}
        </b-badge>
        <b-badge
          pill
          variant="warning"
          v-if="isOnCall && isHolded"
          class="ml-1 p-1 on-call"
        >
          {{ $t("sip.dropdown.holded") }}
        </b-badge>
        <b-button
          variant="danger"
          @click="hangUp()"
          size="sm"
          v-if="isOnCall || isCalling"
          class="mx-1"
          >{{ $t("sip.dropdown.hang_up") }}
        </b-button>
        <div
          class="d-flex align-items-center justify-content-between mx-1"
          v-if="isRinging"
        >
          <span class="font-weight-bolder">
            {{ $t("sip.dropdown.incoming_call") + ` ${callRecieved.callingPartyNumber}` }}
          </span>

          <b-button
            class="float-right"
            pill
            size="sm"
            variant="success"
            @click="answerCall()"
            v-if="!isOnCall"
            >{{ $t("sip.dropdown.answer_call") }}</b-button
          >
          <b-button
            class="float-right mr-1"
            pill
            size="sm"
            variant="danger"
            @click="hangUp()"
            v-if="!isOnCall"
            >{{ $t("sip.dropdown.hang_up") }}</b-button
          >
        </div>
      </div>
    </template>

    <!-- Header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex p-1">
        <h4 class="notification-title mb-0 mr-auto">
          {{ $t("sip.dropdown.calls_title") }}
        </h4>
        <b-badge pill variant="light-primary">
          {{ `${calls.length + pbx_calls.length} ` + $t("sip.dropdown.calls_bandage") }}</b-badge
        >
      </div>
    </li>

    <!-- Notifications -->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="scrollable-container media-list scroll-area"
      tagname="li"
    >
      <b-media v-if="isRinging">
        <template #aside>
          <b-avatar
            size="32"
            text="CALL"
            :style="{ backgroundColor: 'green' }"
            :class="['btn-toggle-config-mode', { 'on-call': isRinging }]"
          >
          </b-avatar>
        </template>
        <p class="media-heading"></p>
        <span class="font-weight-bolder">
          {{ $t("sip.dropdown.incoming_call") + ` ${callRecieved.callingPartyNumber}` }}
        </span>

        <b-button
          class="float-right"
          pill
          size="sm"
          variant="success"
          @click="answerCall()"
          v-if="!isOnCall"
          >{{ $t("sip.dropdown.answer_call") }}</b-button
        >
        <b-button
          class="float-right mr-1"
          pill
          size="sm"
          variant="danger"
          @click="hangUp()"
          v-if="!isOnCall"
          >{{ $t("sip.dropdown.hang_up") }}</b-button
        >
      </b-media>

      <!--Calls List -->
      <b-link v-for="call in calls" :key="call.sessionId">
        <b-media>
          <template #aside>
            <b-avatar size="32" text="IVR" :style="{ backgroundColor: 'green' }">
            </b-avatar>
          </template>
          <p class="media-heading">
            <span class="font-weight-bolder" v-if="call.alarm">
              {{
                `${call.alarm.router.unit.description} - Ext. ${call.callingPartyNumber}`
              }}
              <small class="notification-text float-right">{{
                formatDateAssigned(call.created_at)
              }}</small>
            </span>
            <span class="font-weight-bolder" v-if="!call.alarm">
              {{ `Ext. ${call.callingPartyNumber}` }}
              <small class="notification-text float-right">{{
                formatDateAssigned(call.created_at)
              }}</small>
            </span>
          </p>

          <small class="notification-text mr-1">{{ call.sessionId }}</small>

          <b-button
            class="float-right"
            pill
            size="sm"
            variant="success"
            @click="
              takeCall(call.sessionId, call.callingPartyNumber, call.alarm, 'iotcomms')
            "
            v-if="
              !isOnCall && !isCalling && isConnected == 'Connected' && !lockAnswerCall
            "
          >
            {{ $t("sip.dropdown.answer_call") }}</b-button
          >

          <b-button
            class="float-right"
            pill
            size="sm"
            variant="success"
            disabled
            @click="
              takeCall(call.sessionId, call.callingPartyNumber, call.alarm, 'iotcomms')
            "
            v-if="lockAnswerCall"
          >
            <feather-icon icon="loader" size="16" />
            {{ $t("sip.dropdown.transfering_call") }}
          </b-button>
        </b-media>
      </b-link>

      <!--Calls PBX List -->
      <b-link v-for="call in pbx_calls" :key="call.call_uuid">
        <b-media>
          <template #aside>
            <b-avatar size="32" text="IVR" :style="{ backgroundColor: 'green' }">
            </b-avatar>
          </template>
          <p class="media-heading">
            <span class="font-weight-bolder">
              {{ `Ext. ${call.caller_name}` }}
              <small class="notification-text float-right">{{
                formatDateAssigned(call.timestamp)
              }}</small>
            </span>
          </p>

          <small class="notification-text mr-1">{{ call.call_uuid }}</small>

          <b-button
            class="float-right"
            pill
            size="sm"
            variant="success"
            @click="
              takeCall(call.call_uuid, call.caller_number, false, 'omnicloud')
            "
            v-if="
              !isOnCall && !isCalling && isConnected == 'Connected' && !lockAnswerCall
            "
          >
            {{ $t("sip.dropdown.answer_call") }}</b-button
          >
        </b-media>
      </b-link>
    </vue-perfect-scrollbar>

    <!-- extensions -->
    <softphone
      v-for="device in devices"
      :device="device"
      :key="`${device.provider}-${device.user}`"
    />
  </b-nav-item-dropdown>
  <!-- v-if="UserData.is_master_admin" -->
</template>

<script>
import { EventBus } from "@/libs/event-bus";
import Softphone from "./Softphone.vue";

import {
  BNavItemDropdown,
  BBadge,
  BMedia,
  BLink,
  BAvatar,
  BButton,
  BFormCheckbox,
} from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Ripple from "vue-ripple-directive";
import store from "@/store";
import { computed, ref } from "@vue/composition-api";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { useToast } from "vue-toastification/composition";
import moment from "moment-timezone";

export default {
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BAvatar,
    VuePerfectScrollbar,
    BButton,
    BFormCheckbox,
    Softphone,
  },
  directives: {
    Ripple,
  },
  props: {
  },
  setup(props) {
    //ref to validate the update of this one
    const isConnected = ref("Connected");

    //component refs
    const calls = computed(() => store.getters["sip/getItems"]);
    const pbx_calls = computed(() => store.getters["pbx_calls/getIncomingCalls"]);
    const lockAnswerCall = ref(false);
    const toast = useToast();
    const presavedAlarm = computed(() => {
      return store.state.sip.presavedAlarm;
    });
    const transferUser = ref("");

    store.dispatch("sip_device/getAll");
    store.dispatch("sip/getAll");
    const devices = computed(() => store.getters["sip_device/getItems"]);
    const isOnCall = computed(() => store.state.sip.isOnCall);
    const isCalling = computed(() => store.state.sip.isCalling);
    const isHolded = computed(() => store.state.sip.isHolded);
    const isRinging = computed(() => store.state.sip.isRinging);
    const iconColor = computed(() => store.state.sip.iconColor);
    const unit_user_caller = computed(() => store.state.sip.deviceCaller);
    const timeCall = computed(() => store.state.sip.timeCall);

    const callRecieved = ref({ callingPartyNumber: "" });

    const unregister = () => {
      simpleUser
        .unregister()
        .then(() => {
          console.log("Entro a UNREGISTER");
        })
        .catch((error) => {
          console.error(`[${simpleUser.id}] failed to unregister`);
          console.error(error);
          //alert(`[${simpleUser.id}] Failed to unregister.\n` + error);
        });
    };

    const hangUp = () => {
      EventBus.emit("hang-up");
    };

    const takeCall = (sessionId, caller, alarm, provider) => {
      EventBus.emit("take-call", {
        sessionId,
        caller,
        alarm,
        provider,
      });
    };

    const answerCall = () => {
      EventBus.emit("answer-call");
    };

    const transferCall = () => {
      if (transferUser.value != "") {
        const target = new URI("sip", transferUser.value, domain.value);
        //TODO: make reactive variable
        let transferSession = simpleUser.session;
        simpleUser.hold();
        //Verificar si es .call y este valida si ya hay una sessión activa o .sendInvite por que este es privado
        simpleUser.sendInvite(target);
        simpleUser.session.refer(transferSession);
      }
      transferUser.value = "";
    };

    const holdSession = () => {
      simpleUser.hold();
    };

    const unHoldSession = () => {
      simpleUser.unhold();
    };

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    };

    const formatDateAssigned = (value) => {
      const formattedDate = moment(value).format("DD/MM/YYYY HH:mm:ss");
      return formattedDate;
    };

    EventBus.on(`change-alarm-status`, (params) => {
      if (params == "attended" || params == "canceled") {
        hangUp();
      }
    });

    function formatTime(seconds) {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;

      return `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
    }

    return {
      calls,
      perfectScrollbarSettings,
      unregister,
      hangUp,
      takeCall,
      isOnCall,
      isConnected,
      isRinging,
      isCalling,
      iconColor,
      callRecieved,
      answerCall,
      formatDateAssigned,
      presavedAlarm,
      lockAnswerCall,
      unit_user_caller,
      transferUser,
      transferCall,
      holdSession,
      unHoldSession,
      isHolded,
      devices,

      pbx_calls,

      formatTime,
      timeCall,
    };
  },
};
</script>

<style lang="scss">
@import "../../../../scss/base/bootstrap-extended/include"; // Bootstrap includes
@import "../../../../scss/base/components/include"; // Components includes
@import "../../../../../assets/scss/variables/variables";

.btn-toggle-config-mode {
  transition: transform, 0.2s;
  &.ringing {
    animation: swing ease-in-out 1s infinite alternate;
    transform-origin: center -20px;
    float: left;
  }

  .ringing:after {
    content: "";
    position: absolute;
    width: 20px;
    height: 20px;
    border: 1px solid #999;
    top: -10px;
    left: 50%;
    z-index: 0;
    border-bottom: none;
    border-right: none;
    transform: rotate(45deg);
  }
  /* nail */
  .ringing:before {
    content: "";
    position: absolute;
    width: 5px;
    height: 5px;
    top: -14px;
    left: 54%;
    z-index: 5;
    border-radius: 50% 50%;
    background: #000;
  }

  @keyframes swing {
    0% {
      transform: rotate(3deg);
    }
    100% {
      transform: rotate(-3deg);
    }
  }
}
</style>
